import test3 from "../../../assets/landingPage/test1 (1).png"
import test2 from "../../../assets/landingPage/test1 (2).png"
import test1 from "../../../assets/landingPage/test1 (3).png"
import tincture3 from "../../../assets/landingPage/tincture-3-bonus.png"
import tincture6 from "../../../assets/landingPage/tincture-6-bonus.png"
import tincture9 from "../../../assets/landingPage/tincture-9-bonus.png"





export const pricingData = [
    {
        product: tincture3,
        title: '3 Bottles',
        subtitle: '90 Day Supply',
        pricePerBottle: 49,
        url: "https://scalequick.pay.clickbank.net/?cbitems=4&cbur=a",
        leastpopular: true,
        popular: false,
        freeshipping: 'FAST & FREE SHIPPING',
        originalPrice: "537 ",
        discountedPrice: "147",
        bestValue: false,
        buttonLink: "/",

    },
    {
        product: tincture9,
        title: '9 Bottles',
        subtitle: '270 Day Supply',
        pricePerBottle: 29,
        url: "https://scalequick.pay.clickbank.net/?cbitems=5&cbur=a ",
        leastpopular: true,
        popular: true,
        discount: 'BIGGEST DISCOUNT',
        originalPrice: "1,611",
        freeshipping: 'FAST & FREE SHIPPING',
        bonuses:"2 Bonuses",
        discountedPrice: "261",
        bestValue: true,
        buttonLink: "/",

    },
    {
        product: tincture6,
        title: '6 Bottles',
        subtitle: '180 Day Supply',
        pricePerBottle: 39,
        url: "https://scalequick.pay.clickbank.net/?cbitems=6&cbur=a",
        leastpopular: false,
        popular: false,
        freeshipping: 'FAST & FREE SHIPPING',
        bonuses: ' 2 Bonuses',
        originalPrice: "1,074 ",
        discountedPrice: "234",
        bestValue: false,
        buttonLink: "/",

    },

]



export const images = [
    { id: "bottom-testi1", src: "https://cdn.blackincae.com/product-images/sinoclear-feedback-04.png", alt: "testi-3b-min jpg" },
    { id: "bottom-testi2", src: "https://cdn.blackincae.com/product-images/sinoclear-feedback-01.png", alt: "testi-7-min jpg" },
    { id: "bottom-testi3", src: "https://cdn.blackincae.com/product-images/sinoclear-feedback-03.png", alt: "testi-2-min (1) jpg" },
    { id: "bottom-testi4", src: "https://cdn.blackincae.com/product-images/sinoclear-feedback-02.png", alt: "testi-6-min jpg" },
];


export const testimonials = [
    {
        id: 1,
        img: test1, // Path to Tom's image
        text: "I’ve tried countless lung health supplements, but nothing works like Lung Renew. It helps me breathe easier and supports my respiratory health without any harsh side effects. I feel a noticeable difference in my lung capacity and overall well-being. Highly recommend for anyone looking to improve their breathing!",
        name: "Tom L.",
    },
    {
        id: 2,
        img: test2, // Path to Sarah's image
        text: "I've struggled with shortness of breath for years, especially during allergy season. After trying Lung Renew, I felt an instant difference. It helps clear my airways and makes breathing feel effortless. It's now my go-to solution for respiratory support!",
        name: "Sarah J.",
    },
    {
        id: 3,
        img: test3, // Path to Mark's image
        text: "I love that Lung Renew is made with natural ingredients. It’s so much safer and more effective than other lung health products I’ve tried. I can feel the difference in just a few days, and it helps keep my lungs strong and clear. It’s a must-have in my daily routine!",
        name: "Mark D.",
    },
];


export const stores = [
    {
        name: 'Walgreens',
        logo: 'https://sinoclear.net/pm/images/X-Walgreens_2020_primary_logo.svg'
    },
    {
        name: 'Walmart',
        logo: 'https://sinoclear.net/pm/images/X-Walmart_logo.svg'
    },
    {
        name: 'GNC',
        logo: 'https://sinoclear.net/pm/images/x-gnc-live-well-2.svg'
    },
    {
        name: 'CVS',
        logo: 'https://sinoclear.net/pm/images/X-CVS_Pharmacy_Alt_Logo.svg'
    }
];


export const studies = [
    { id: '01', url: 'https://phys.org/news/2007-05-radiation-eating-fungi.html#google_vignette' },
    { id: '02', url: 'https://www.ncbi.nlm.nih.gov/pubmed/9932596' },
    { id: '03', url: 'https://www.ncbi.nlm.nih.gov/pubmed/25339490' },
    { id: '04', url: 'https://ijmd.com/detox-from-mold-glutathione-mother-of-all-antioxidants/' },
    { id: '05', url: 'https://www.ncbi.nlm.nih.gov/pubmed/27117852' },
    { id: '06', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7892733/#Sec20title' },
    { id: '07', url: 'https://www.sciencedirect.com/science/article/pii/S1756464614002400' },
    { id: '08', url: 'https://pubmed.ncbi.nlm.nih.gov/28198157/' },
    { id: '09', url: 'https://www.ncbi.nlm.nih.gov/pubmed/27207147' },
    { id: '10', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3706886/' },
    { id: '11', url: 'https://pubmed.ncbi.nlm.nih.gov/12452574/' },
    { id: '12', url: 'https://jamanetwork.com/journals/jamaotolaryngology/fullarticle/509953' },
    { id: '13', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4443571/' },
    { id: '14', url: 'https://www.ncbi.nlm.nih.gov/labs/pmc/articles/PMC7892733/' },
    { id: '15', url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4744393/' },
    { id: '16', url: 'https://fdc.nal.usda.gov/fdc-app.html#/food-details/171727/nutrients' },
    { id: '17', url: 'https://pubmed.ncbi.nlm.nih.gov/22129334/' },
    { id: '18', url: 'https://www.ncbi.nlm.nih.gov/pubmed/18356331' },
    { id: '19', url: 'https://www.webmd.com/diet/health-benefits-thyme#:~:text=Thyme%20may%20help%20with%3A,well%20as%20in%20the%20kitchen' },
    { id: '20', url: 'https://www.medicalnewstoday.com/what_is_bromelain_good_for/article.htm#:~:text=Chronic%20sinusitis%20(chronic%20rhinosinusitis),not%20as%20substitute%20for%20conventional%20chemotherapy' }
];